import React, { Suspense } from 'react';
import '../components/advertise-with-us/css/advertisewithus.css';
import AdvertiseSection from '../components/advertise-with-us/AdvertiseSection';
import HowItWorksSection from '../components/advertise-with-us/HowItWorksSection';
// import Feature360Section from './Feature360Section';
import Feature360Section1 from '../components/advertise-with-us/Feature360Section1';
import BrandsSection from '../components/advertise-with-us/BrandsSection';
import IndustryTapeSection from '../components/advertise-with-us/IndustryTapeSection';
import TravelerFlowSection from '../components/advertise-with-us/TravelerFlowSection';
// import WhereBrandAppearsSection from './WhereBrandAppearsSection';
// import OurVisionSection from './OurVisionSection';
import FAQSection from '../components/advertise-with-us/FAQSection';
import CampaignCTASection from '../components/advertise-with-us/CampaignCTASection';

function AdvertiseWithUs() {
  return (
    <div className="trw-advertise-with-us min-h-screen flex flex-col">

      <main className="flex-grow">
        <AdvertiseSection />
        {/* <Feature360Section /> */}
        <Feature360Section1 />
        <BrandsSection />

        <IndustryTapeSection />
        <TravelerFlowSection />
        <HowItWorksSection />
        {/* <WhereBrandAppearsSection /> */}
        {/* <OurVisionSection /> */}
        <FAQSection />
        <CampaignCTASection />



      </main>

    </div>
  );
}

export default AdvertiseWithUs;
